import * as types from "./types";
import _ from 'lodash';

export const defaultState = {
  featured: {},
  all: {},
  loading_all: {},
  loading_featured: {},
  errors_all: [],
  errors_featured: [],
  has_more_all: [],
  has_more_featured: [],
  next_featured_offset: {},
  next_all_offset: {}
};

const circles_in_collection = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCHED_CIRCLE:
    if (action.featured) {      
      let existent_circles = [];
      if (state.featured[action.collection]) {
        existent_circles = [...state.featured[action.collection]];
      }
      const new_circles = existent_circles.push(action.circle);
      return {
        ...state,
        featured: {
          ...state.featured,
          [action.collection]: new_circles
        },
        loading_featured: {
          ...state.loading_featured,
          [action.collection]: action.loading
        }         
      };
    } else {
      let existent_circles = state.all;       
      existent_circles[action.circle.guid] = action.circle;
      return {
        ...state,
        all: {
          ...state.all,
          [action.collection]: [
            ...state.all[action.collection],
            action.circle
          ]
        },
        loading_all: {
          ...state.loading_all,
          [action.collection]: action.loading
        } 
      };
    }
    case types.FETCHED_CIRCLES:
      if (action.featured) {          
        let existent_circles = [];
        if (state.featured[action.collection]) {
          existent_circles = [...state.featured[action.collection]];
        }
        const new_circles =_.unionBy(existent_circles, action.circles, 'circle_guid');
        return {
          ...state,
          featured: {
            ...state.featured,
            [action.collection]: new_circles
          },
          next_featured_offset: {
            ...state.next_featured_offset,
            [action.collection]: action.offset + action.limit
          },
          loading_featured: {
            ...state.loading_featured,
            [action.collection]: action.loading
          },
          has_more_featured: {
            ...state.has_more_featured,
            [action.collection]: action.has_more
          }        
        };
      } else {
        let existent_circles = [];
        if (state.all[action.collection]) {
          existent_circles = [...state.all[action.collection]];
        }
        const new_circles =_.unionBy(existent_circles, action.circles, 'circle_guid');
        return {
          ...state,
          all: {
            ...state.all,
            [action.collection]:  new_circles
          },
          next_all_offset: {
            ...state.next_all_offset,
            [action.collection]: action.offset + action.limit
          },
          loading_all: {
            ...state.loading_all,
            [action.collection]: action.loading
          },
          has_more_all: {
            ...state.has_more_all,
            [action.collection]: action.has_more
          }
        };
      }
    case types.FETCHING_CIRCLES:
      if (action.featured) {
        return {
          ...state,
          loading_featured: {
            ...state.loading_featured,
            [action.collection]: action.loading
          },
        };
      } else {
        return {
          ...state,
          loading_all: {
            ...state.loading_all,
            [action.collection]: action.loading
          }
        };
      }
    case types.ERROR_FETCHING_CIRCLES:
      if (action.featured) {
        return {
          ...state,
          errors_featured: [...state.errors, action.error],
          loading_featured: {
            ...state.loading_featured,
            [action.collection]: action.loading
          }
        };
      } else {
        return {
          ...state,
          errors_all: [...state.errors, action.error],
          loading_all: {
            ...state.loading_all,
            [action.collection]: action.loading
          }
        };
      }

    default:
      return state;
  }
};
export default circles_in_collection;
